import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { PermissionserrorComponent } from './permissionserror';

const routes: Routes = [
  {
    path: '',
    component: PermissionserrorComponent
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class AuthorizationRoutingModule { }
